<script setup>
import arrow from './block-title-arrow.svg'

const imgArrow = arrow
</script>

<template lang="pug">
div.web-block-title.flex.flex-row.justify-center.items-center.bg-no-repeat.bg-bottom.pb-4.text-center.font-bold.text-2xl.mb-8(:style="{ backgroundImage: `url('${imgArrow}')`, minWidth: '5em' }")
  slot
</template>
